import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Nav.css";

const logoStyle = {
  marginBottom: "0px",
  width: "46px"
};
class Nav extends Component {
  state = {
    showMobileNav: false
  };
  render() {
    const toggleMobileNav = () => {
      this.setState({ showMobileNav: !this.state.showMobileNav });
    };
    return (
      <div>
        <header id="header" className="fixed-nav" style={{ top: 0 }}>
          <section className="container clearfix" style={{ marginTop: 0 }}>
            <div className="logo">
              <a
                className="logo-img"
                href="https://kinnectedapp.com/"
                itemProp="url"
                title="Kinnected"
              >
                <img
                  width="46"
                  height="120"
                  style={logoStyle}
                  className="default_logo"
                  itemProp="logo"
                  alt="Kinnected"
                  src="https://kinnectedapp.com/wp-content/uploads/2018/12/KinnectedNewLogo.png"
                />
                <img
                  width="46"
                  height="120"
                  style={logoStyle}
                  className="retina_logo"
                  itemProp="logo"
                  alt="Kinnected"
                  src="https://kinnectedapp.com/wp-content/uploads/2018/12/KinnectedNewLogo.png"
                />
              </a>
              <meta itemProp="name" content="Kinnected" />
            </div>
            <nav className="navigation">
              <div className="header-menu">
                <ul id="menu-home-1" className="">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home page_item page-item-26  menu-item-288">
                    <a className="" href="https://kinnectedapp.com/">
                      <i className="_mi _before dashicons dashicons-admin-home" aria-hidden="true" />
                      <span>Home</span>
                    </a>
                  </li>

                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-175">
                    <a className="" href="https://kinnectedapp.com/news-feed/">
                      <i
                        className="_mi _before dashicons dashicons-welcome-write-blog"
                        aria-hidden="true"
                      />
                      <span>News Feed</span>
                    </a>
                  </li>

                  <li className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-141">
                    <Link className="" to="/">
                      <i
                        className="_mi _before dashicons dashicons-welcome-learn-more"
                        aria-hidden="true"
                      />
                      <span>Resources</span>
                    </Link>
                  </li>

                  <li className="menu-item menu-item-type-post_type_archive menu-item-object-question menu-item-22">
                    <a className="" href="https://kinnectedapp.com/questions/">
                      <i className="_mi _before dashicons dashicons-pressthis" aria-hidden="true" />
                      <span>Q &amp; A</span>
                    </a>
                  </li>

                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-23">
                    <a className="" href="https://kinnectedapp.com/profile/">
                      <i className="_mi _before dashicons dashicons-admin-users" aria-hidden="true" />
                      <span>Profile</span>
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
            <div className="mobile-menu">
              <div
                style={{ marginTop: "18px" }}
                onClick={() => toggleMobileNav()}
                className="mobile-menu-click navigation_mobile"
              />
            </div>
          </section>

          <aside
            style={this.state.showMobileNav ? { display: "block" } : { display: "none" }}
            className="mobile-aside mobile-menu-wrap aside-no-cart dark-mobile-menu mobile-aside-open"
          >
            <div className="mobile-aside-inner mCustomScrollbar _mCS_2">
              <div
                id="mCSB_2"
                className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                style={{ maxHeight: "none" }}
                tabIndex="0"
              >
                <div
                  id="mCSB_2_container"
                  className="mCSB_container"
                  style={{ position: "relative", left: "0px" }}
                  dir="ltr"
                >
                  <div className="mobile-aside-inner-inner" style={{ position: "fixed" }}>
                    <a href="#" onClick={() => toggleMobileNav()} className="mobile-aside-close">
                      x
                    </a>
                    <div className="mobile-menu-top mobile-aside-menu">
                      <div className="header-top">
                        <ul id="menu-top-bar-login" className="menu_aside">
                          <li
                            id="menu-item-227"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-227"
                          >
                            <a
                              className=""
                              title="fa fa-lg fa-home"
                              href="https://kinnectedapp.com/news-feed/add-post/"
                            >
                              <i className="_mi _before dashicons dashicons-edit" aria-hidden="true" />
                              <span>Add Post</span>
                            </a>
                          </li>
                          <li
                            id="menu-item-252"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-252"
                          >
                            <a className="" href="https://kinnectedapp.com/contact-us/">
                              <i
                                className="_mi _before dashicons dashicons-email-alt"
                                aria-hidden="true"
                              />
                              <span>Contact Us</span>
                            </a>
                          </li>
                          <li
                            id="menu-item-305"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-305"
                          >
                            <a className="" href="https://kinnectedapp.com/faqs/">
                              FAQS
                            </a>
                          </li>
                          <li
                            id="menu-item-82"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-82"
                          >
                            <a className="" href="https://kinnectedapp.com/privacy-policy/">
                              <i
                                className="_mi _before dashicons dashicons-admin-page"
                                aria-hidden="true"
                              />
                              <span>Terms of Service</span>
                            </a>
                          </li>
                        </ul>
                      </div>{" "}
                    </div>
                    <div className="ask-question-menu">
                      <a
                        href="https://kinnectedapp.com/user-add-question/"
                        className="color button small margin_0"
                      >
                        Ask a Question
                      </a>
                    </div>

                    <div className="mobile-menu-left mobile-aside-menu">
                      <div className="header-menu">
                        <ul id="menu-home" className="menu_aside">
                          <li
                            id="menu-item-288"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-288"
                          >
                            <a className="" href="https://kinnectedapp.com/">
                              <i
                                className="_mi _before dashicons dashicons-admin-home"
                                aria-hidden="true"
                              />
                              <span>Home</span>
                            </a>
                          </li>
                          <li
                            id="menu-item-175"
                            className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-169 current_page_item menu-item-175"
                          >
                            <a className="" href="https://kinnectedapp.com/news-feed/">
                              <i
                                className="_mi _before dashicons dashicons-welcome-write-blog"
                                aria-hidden="true"
                              />
                              <span>News Feed</span>
                            </a>
                          </li>
                          <li
                            id="menu-item-141"
                            className="menu-item menu-item-type-custom menu-item-object-custom menu-item-141"
                          >
                            <a className="" href="https://dev--kinnectedapp.netlify.com/">
                              <i
                                className="_mi _before dashicons dashicons-welcome-learn-more"
                                aria-hidden="true"
                              />
                              <span>Resources</span>
                            </a>
                          </li>
                          <li
                            id="menu-item-22"
                            className="menu-item menu-item-type-post_type_archive menu-item-object-question menu-item-22"
                          >
                            <a className="" href="https://kinnectedapp.com/questions/">
                              <i
                                className="_mi _before dashicons dashicons-pressthis"
                                aria-hidden="true"
                              />
                              <span>Q &amp; A</span>
                            </a>
                          </li>
                          <li
                            id="menu-item-23"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-23"
                          >
                            <a className="" href="https://kinnectedapp.com/profile/">
                              <i
                                className="_mi _before dashicons dashicons-admin-users"
                                aria-hidden="true"
                              />
                              <span>Profile</span>
                            </a>
                          </li>
                        </ul>
                      </div>{" "}
                    </div>
                    <div className="social_icons f_right">
                      <ul>
                        <li className="twitter">
                          <a
                            target="_blank"
                            original-title="Twitter"
                            className="tooltip-n"
                            href="https://twitter.com/KinnectedApp_"
                          >
                            <i className="social_icon-twitter font17" />
                          </a>
                        </li>
                        <li className="facebook">
                          <a
                            target="_blank"
                            original-title="Facebook"
                            className="tooltip-n"
                            href="https://www.facebook.com/KinnectedApp/"
                          >
                            <i className="social_icon-facebook font17" />
                          </a>
                        </li>
                        <li className="instagram">
                          <a
                            target="_blank"
                            original-title="Instagram"
                            className="tooltip-n"
                            href="https://www.instagram.com/kinnectedapp_/"
                          >
                            <i className="social_icon-instagram font17" />
                          </a>
                        </li>
                        <li className="linkedin">
                          <a
                            target="_blank"
                            original-title="Linkedin"
                            className="tooltip-n"
                            href="https://www.linkedin.com/company/kinnectedapp/"
                          >
                            <i className="social_icon-linkedin font17" />
                          </a>
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                </div>
                <div
                  id="mCSB_2_scrollbar_vertical"
                  className="mCSB_scrollTools mCSB_2_scrollbar mCS-light mCSB_scrollTools_vertical"
                  style={{ display: "block" }}
                >
                  <div className="mCSB_draggerContainer">
                    <div
                      id="mCSB_2_dragger_vertical"
                      className="mCSB_dragger"
                      style={{
                        position: "absolute",
                        minHeight: "30px",
                        top: "34px",
                        display: "block",
                        height: "738px",
                        maxHeight: "762px"
                      }}
                    >
                      <div className="mCSB_dragger_bar" style={{ lineHeight: "30px" }} />
                    </div>
                    <div className="mCSB_draggerRail" />
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </header>
      </div>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js